import {useEffect, useState} from 'react';
import Button from 'infrastructure/js/components/controls/Button/button';
import {PL_NoFormComboBox} from 'infrastructure/js/components/controls/Combobox/combobox';
import useLabels from 'infrastructure/js/hooks/useLabels';
import MobileHeader from '../Common/MobileHeader/mobileHeader';
import ArrowLeftIcon from 'infrastructure/assets/svg/tab-arrow-left.svg';
import FullScreenToggle from 'infrastructure/js/components/FullScreenToggle/fullScreenToggle';

require('./moveAssetsChangeLocation.scss');

export default function MoveAssetsChangeLocation ({ history,
                                                    locations=[],
                                                    assets=[],
                                                    onClickCallback=null,
                                   }) {

  const [selectedLocation, setSelectedLocation] = useState(null);
  const labels = useLabels('mat.mobile.changeLocationPage.');

  useEffect(() => {
    if (!assets?.length) {
      history.push('/Mobile');
    }
  }, []);


  const onSelectLocationHandler = (value, oldValue) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      setSelectedLocation(null);
      return;
    }
    setSelectedLocation(value);
  };


  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'leftButton',
          icon: ArrowLeftIcon,
          className: 'divider-right',
          action: () => history.replace('/MoveAssets'),
        },
        {
          id: 'assetDetails',
          label: labels.get('header.title'),
        },
        {
          id: 'fullScreenButton',
          className: 'divider-left',
          buttonComponent: FullScreenToggle
        },
      ]
    }
  }

    return (
      <div className="assets-change-location">
        <MobileHeader {...getHeaderItems()} />
        <div className="content">
          <div className="location-input">
            <label>{labels.get('input.label')}</label>
            <PL_NoFormComboBox
                id="change-location"
                name="location"
                className="select-location"
                autoFocus
                options={locations}
                placeholder={labels.get('input.placeholder')}
                blurInputOnSelect={false}
                onChangeCallback={onSelectLocationHandler}
            />
            <div className="barcode-input-error">
            </div>
          </div>

          <Button bsStyle="primary" className="change-location-btn"
                  id='change-location-btn'
                  disabled={!selectedLocation }
                  onClick={() => onClickCallback?.(selectedLocation)}
            >
            {labels.get('button.changeLocation')}
          </Button>

        </div>
      </div>
    )
}


MoveAssetsChangeLocation.propTypes = {
};


